// extracted by mini-css-extract-plugin
module.exports = {"root":"ZoUakMeBIv0dG7haPqnw"};